import { Component } from 'react';

interface Props {
  text: string;
  maxLength: number;
}
interface State {
  showMore: boolean;
}

class ReadMore extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      showMore: false,
    };
  }

  private expandText(check: boolean) {
    this.setState({
      showMore: check,
    });
  }

  public render() {
    const { text, maxLength } = this.props;

    if (text.length > maxLength) {
      return (
        <div>
          {this.state.showMore ? (
            <div>
              {text} {'  '}
              <span
                className="lil-cursor-pointer lil-text-blue-350 lil-text-s-14 lil-font-semibold"
                onClick={() => this.expandText(false)}
              >
                Read less
              </span>
            </div>
          ) : (
            <div>
              {text.slice(0, maxLength)}... {'  '}
              <span
                className="lil-cursor-pointer lil-text-blue-350 lil-text-s-14 lil-font-semibold"
                onClick={() => this.expandText(true)}
              >
                Read more
              </span>
            </div>
          )}
        </div>
      );
    }

    return <div>{text}</div>;
  }
}

export default ReadMore;



// WEBPACK FOOTER //
// ./components/common/readmore.tsx